import { defineRoute, defineActionRoute, NotFound } from '@colescba/ui'

import Home from '@/views/Home'
import Comprobantes from '@/views/Comprobantes'
import GenerarComprobante from '@/views/GenerarComprobante'
import FormularioComprobante from '@/views/FormularioComprobante'
import VerListaComprobantes from '@/views/VerListaComprobantes'
import PagarComprobante from '@/views/PagarComprobante'
import VerComprobante from '@/views/VerComprobante'
import VerRecibo from '@/views/VerRecibo'
import UsarComprobante from '@/views/UsarComprobante'
import Devoluciones from '@/views/Devoluciones'
import TransferenciaSedes from '@/views/TransferenciaSedes'
import RevisionComprobantes from '@/views/RevisionComprobantes'
import ReporteFacturacion from '@/views/ReporteFacturacion'

const subLinkUsarComprobante = defineActionRoute(
  {
    path: '/comprobantes-terceros/registrar-uso',
    name: 'usar-comprobante',
    component: UsarComprobante,
    props: true,
  },
  {
    text: 'Registrar uso de comprobantes',
    description:
      'Registrar o anular el uso de comprobantes de tasas varias y su asociación con la respectiva factura de América.',
  },
  { svg: 'OutlineClipboardCheckIcon' },
  false, // isNavigationLink,
  true, // isHamburgerLink,
  'ACCION_CAJERO'
)

const subLinkDevoluciones = defineActionRoute(
  {
    path: '/comprobantes-terceros/devoluciones',
    name: 'devoluciones',
    component: Devoluciones,
    props: true,
  },
  { text: 'Devoluciones', description: 'Registrar la devolución de comprobantes de tasas varias.' },
  { svg: 'OutlineReceiptRefundIcon' },
  false, // isNavigationLink,
  true, // isHamburgerLink,
  'ACCION_AGENTETESORERIA'
)

const subLinkTransferenciaSedes = defineActionRoute(
  {
    path: '/comprobantes-terceros/transferencia-sedes',
    name: 'transferencia-sedes',
    component: TransferenciaSedes,
    props: true,
  },
  {
    text: 'Transferencia entre sedes',
    description: 'Transferir comprobantes de tasas varias de una sede a otra.',
  },
  { svg: 'OutlineSwitchHorizontalIcon' },
  false, // isNavigationLink,
  true, // isHamburgerLink,
  'ACCION_AGENTETESORERIA'
)

const subLinkRevisionComprobantes = defineActionRoute(
  {
    path: '/comprobantes-terceros/revision',
    name: 'revision',
    component: RevisionComprobantes,
    props: true,
  },
  {
    text: 'Revisión de comprobantes',
    description:
      'Listado de comprobantes de tasas varias, con posibilidad de búsqueda por distintos filtros.',
  },
  { svg: 'OutlineDocumentSearchIcon' },
  false, // isNavigationLink,
  true, // isHamburgerLink,
  ['ACCION_CAJERO', 'ACCION_AGENTETESORERIA']
)

const subLinkReporteFacturacion = defineActionRoute(
  {
    path: '/comprobantes-terceros/reporte-facturacion',
    name: 'reporte-facturacion',
    component: ReporteFacturacion,
    props: true,
  },
  {
    text: 'Reporte de facturación',
    description:
      'Listado de facturas de América asociadas a comprobantes de tasas varias, con posibilidad de búsqueda por distintos filtros.',
  },
  { svg: 'OutlineViewListIcon' },
  false, // isNavigationLink,
  true, // isHamburgerLink,
  ['ACCION_AGENTECONTADURIA', 'ACCION_AGENTETESORERIA']
)

export default [
  defineRoute(
    {
      path: '/',
      name: 'Home',
      component: Home,
      props: true,
    },
    { text: 'Inicio' },
    { svg: 'OutlineHomeIcon' },
    true, // isNavigationLink,
    true // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/comprobantes',
      name: 'comprobantes',
      component: Comprobantes,
      props: route => ({ tipoDeudaId: route.query['tipo-deuda'] }),
    },
    { text: 'Comprobantes de pago' },
    { svg: 'OutlineCollection' },
    true, // isNavigationLink,
    true // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/nuevo-comprobante',
      name: 'generar-comprobante',
      component: GenerarComprobante,
      props: true,
    },
    { text: 'Generar comprobante de pago' },
    { svg: 'OutlinePlusCircleIcon' },
    true, // isNavigationLink,
    true // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/formularios/:idFormulario',
      name: 'formulario-comprobante',
      component: FormularioComprobante,
      props: true,
    },
    { text: 'Generar comprobante de pago' },
    null, // icon
    false, // isNavigationLink,
    false // isHamburgerLink,
  ),
  defineRoute(
    {
      path: '/ver-comprobantes',
      name: 'ver-comprobantes',
      component: VerListaComprobantes,
      props: true,
    },
    { text: 'Lista de comprobantes' },
    null, // icon
    false, // isNavigationLink,
    false // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/deuda-comprobante/:idDeuda/pagar',
      name: 'pagar-comprobante',
      component: PagarComprobante,
      props: true,
    },
    { text: 'Pagar comprobante' },
    null, // icon
    false, // isNavigationLink,
    false // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/comprobantes/:nroComprobante',
      name: 'ver-comprobante',
      component: VerComprobante,
      props: true,
    },
    { text: 'Ver comprobante' },
    null, // icon
    false, // isNavigationLink,
    false // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/comprobantes/:nroComprobante',
      path: '/comprobantes/:nroComprobante/recibo',
      name: 'ver-recibo',
      component: VerRecibo,
      props: true,
    },
    { text: 'Ver recibo' },
    null, // icon
    false, // isNavigationLink,
    false // isHamburgerLink,
  ),

  subLinkDevoluciones,
  subLinkTransferenciaSedes,
  subLinkRevisionComprobantes,
  subLinkUsarComprobante,
  subLinkReporteFacturacion,

  defineActionRoute(
    {
      path: '/comprobantes-tasas-varias',
      props: true,
      secondaryNavigation: [
        {
          meta: subLinkDevoluciones.meta,
          route: subLinkDevoluciones,
          name: subLinkDevoluciones.name,
        },
        {
          meta: subLinkTransferenciaSedes.meta,
          route: subLinkTransferenciaSedes,
          name: subLinkTransferenciaSedes.name,
        },
        {
          meta: subLinkRevisionComprobantes.meta,
          route: subLinkRevisionComprobantes,
          name: subLinkRevisionComprobantes.name,
        },
        {
          meta: subLinkUsarComprobante.meta,
          route: subLinkUsarComprobante,
          name: subLinkUsarComprobante.name,
        },
        {
          meta: subLinkReporteFacturacion.meta,
          route: subLinkReporteFacturacion,
          name: subLinkReporteFacturacion.name,
        },
      ],
    },
    { text: 'Comprobantes de tasas varias' },
    { svg: 'BoxIconCycling', classes: 'fill-current text-colescba-blue-600' },
    true, // isNavigationLink,
    false, // isHamburgerLink,
    ['ACCION_CAJERO', 'ACCION_AGENTETESORERIA', 'ACCION_AGENTECONTADURIA']
  ),

  // siempre al final esta ruta
  defineRoute(
    {
      path: '*',
      name: 'NotFound',
      props: true,
      component: NotFound,
    },
    { text: '' },
    null,
    false,
    false,
    {
      fullScreen: true,
    }
  ),
]
